module.exports = __webpack_public_path__ + "static/django-9ecb7250e9469dc02c645b795bf56767.png";